import React, { useState } from 'react'
import { validateEmail } from '../../../../../helpers'
import { CardSection, CardHeader, CardItem } from '../../../../../components/Card';
import Divider from '../../../../../components/Divider';
import Button from '../../../../../components/inputs/Button';
import { useForm, useFetch } from '../../../../../hooks';
import FromInput from '../../../../../components/inputs/FromInput';
import { Element, ElementTitle } from '../styled';
import Buttons from '../../../../../modules/Buttons';

const Contact = ({ data: { buttons, data, title }, refetchAccount }) => {

    const { doFetch } = useFetch({
        url: `/rpc/setcontact`,
        method: 'POST'
    })

    const [isEditMode, setEditMode] = useState(false);

    const validate = values => {
        const errors = {}

        // if (values.phone.length !== 0 && values.phone.length !== 9) {
        //     errors.phone = "Wprowadź 9-cyfrowy numer telefonu"
        // }

        if (!validateEmail(values.email)) {
            errors.email = "Wprowadź poprawny adres email";
        }

        return errors
    }

    const save = values => {
        doFetch({
            data: values
        }).then(res => {
            if (res === 1) {
                setEditMode(false)
                refetchAccount();
            } else {
                throw Error(res)
            }
        }).catch(err => {
            console.log(err);
        })
    }

    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: save,
        validate: validate,
        initValues: {
            description: data[0].description,
            phone: data[0].phone === null ? '' : data[0].phone,
            email: data[0].email === null ? '' : data[0].email,
        }
    })

    return (
        <CardSection>
            <CardHeader>{title}</CardHeader>
            <Divider />
            {isEditMode ? (
                <form onSubmit={handleSubmit}>
                    <Element>
                        <ElementTitle>{data[0]['description-label']}</ElementTitle>
                        <FromInput
                            type='text'
                            placeholder={data[0]['description-placeholder']}
                            name='description'
                            onChange={handleChange}
                            value={values.description}
                            error={errors.description}
                        />
                    </Element>
                    <Element>
                        <ElementTitle>{data[0]['phone-label']}</ElementTitle>
                        <FromInput
                            type='number'
                            placeholder={data[0]['phone-placeholder']}
                            name='phone'
                            onChange={handleChange}
                            value={values.phone}
                            error={errors.phone}
                        />
                    </Element>
                    <Element>
                        <ElementTitle>{data[0]['email-label']}</ElementTitle>
                        <FromInput
                            type='text'
                            placeholder={data[0]['email-placeholder']}
                            name='email'
                            onChange={handleChange}
                            value={values.email}
                            error={errors.email}
                        />
                    </Element>
                    <Buttons stretch>
                        <Button
                            type="button"
                            width="48%"
                            onClick={() => setEditMode(false)}
                        >
                            {buttons.cancel}
                        </Button>
                        <Button type="submit" green width="48%">
                            {buttons.save}
                        </Button>
                    </Buttons>
                </form>
            ) : (
                    <>
                        <CardItem
                            left={{
                                name: data[0].description
                            }}
                        />
                        <CardItem
                            left={{
                                name: data[0].phone
                            }}
                        />
                        <CardItem
                            left={{
                                name: data[0].email
                            }}
                        />
                        <Button green fullWidth onClick={() => setEditMode(true)}>{buttons.edit}</Button>
                    </>
                )}

        </CardSection>
    )
}

export default Contact
